import React from 'react';
import { useSelector } from 'react-redux';

const townships = [
    { id: '3bc75db1-931a-42b1-a6cc-1563a9f394db', area: "Windhoek", name: 'Windhoek' },
    { id: '6dd6b31f-d289-4a50-a14e-5a443824907d', area: "Windhoek", name: 'Sungate' },
    { id: '47dc9bed-89e2-4689-949d-878bd6344c8d', area: "Windhoek", name: 'Herbothblick' },
    { id: 'd17cee17-b707-4b6d-9e7e-334ba4c4bbb9', area: "Windhoek", name: 'Farm Ondekaremba No 78' },
    { id: '427048e4-e2b9-4e68-ad24-b80fed8771f2', area: "Windhoek", name: 'Farm Manyhills No 580' },
    { id: 'a45df01f-0bc6-4912-9f2a-dfa612d792d1', area: "Windhoek", name: 'Farm Regenstein 32' },
    { id: '8f42ae76-1a36-4e50-9a8f-cead8272af69', area: "Windhoek", name: 'Eros Park' },
    { id: '2f9acdab-3abc-4e3b-8464-b3d91dae6462', area: "Windhoek", name: 'Klein Whk' },
    { id: '706dea59-6a94-47ec-8f4d-cbfdefe3858f', area: "Windhoek", name: 'Farm Eros No 69' },
    { id: '2fa08d2c-a5d6-4f61-88c1-18f1ccb4a159', area: "Windhoek", name: 'Farm Klein Whk Town & Townland No 70' },
    { id: '8721d34e-6ec4-4a12-b52b-6e406e61c96f', area: "Windhoek", name: 'Farm Whk Town & Townlands No 31' },
    { id: '0d2a3a5b-0498-4674-8b19-7b5f975102e1', area: "Windhoek", name: 'Farm Finckenstein; Finkenstein' },
    { id: '1f4ea233-a9e0-4b42-9f70-4b4cf9a8e4fa', area: "Windhoek", name: 'Omeya' },
    { id: '96638a8e-4a07-4109-928f-63c3e9899baf', area: "Windhoek", name: 'Olympia' },
    { id: '832a395d-cfa1-4d89-b8d6-097fa90142ce', area: "Windhoek", name: 'AuasBlick' },
    { id: '5042cab1-7673-4df4-a78b-7a4bfbf89c6c', area: "Windhoek", name: 'Kleine Kuppe' },
    { id: 'db7060b5-c7c4-41b4-80aa-c8308aff8881', area: "Windhoek", name: 'Pionierspark' },
    { id: '25faa83d-b479-4ff1-8641-08626467837b', area: "Windhoek", name: 'Cimbebasia' },
    { id: '0e4ac2fd-4031-497d-90fc-da7cd18661af', area: "Windhoek", name: 'Prosperita' },
    { id: '3007099f-78c4-4d44-85d9-c25c8c601da4', area: "Windhoek", name: 'Academia' },
    { id: 'b283ca78-5537-4f47-bdc0-846f3a6cb2f3', area: "Windhoek", name: 'Hochlandpark' },
    { id: 'e78a401d-9e20-4239-ab65-7bc42bfb1e64', area: "Windhoek", name: 'Rocky Crest' },
    { id: 'ae5d18ad-470c-4cee-94bf-74fc78d0f826', area: "Windhoek", name: 'Katutura' },
    { id: '469293ba-304b-4b4b-824f-36fb9694301b', area: "Windhoek", name: 'Khomasdal' },
    { id: 'bf45e53b-f42a-48bb-9d25-474f49b00f01', area: "Windhoek", name: 'Dorado Park' },
    { id: '96589887-e8ac-4bdd-81cd-2b1c2596cad0', area: "Windhoek", name: 'Otjomuise' },
    { id: '0d073714-f2ef-4587-94e3-29146c549f30', area: "Windhoek", name: 'Goreangab' },
    { id: '088c2112-ade5-483d-a7c9-1351038fcd00', area: "Windhoek", name: 'Groot Aub' },
    { id: 'e4a1adcf-6535-4f8f-91c0-04d3c4c85e9e', area: "Windhoek", name: 'Hakahana' },
    { id: 'c7625e9a-aa30-433c-8aa5-9b67cbea0748', area: "Windhoek", name: 'Hillside' },
    { id: '2023885c-c9ad-430e-a84b-98bddb9ef333', area: "Windhoek", name: 'Brakwater Industrial Estate' },
    { id: 'b7cbbfb0-df12-4ab1-a48b-88cd8a7c3873', area: "Windhoek", name: 'Farm 428' },
    { id: '1d75385d-3fd7-483b-b0be-9e7d7005a456', area: "Windhoek", name: 'Elisenheim' },
    { id: 'fa550e69-9d84-4ba1-b9ae-e5f0cdf8c820', area: "Windhoek", name: 'Wanaheda' },
    { id: '7bd08e38-e96c-4aeb-af98-55dcfb7cf7f4', area: "Windhoek", name: 'Havana' },
    { id: '907253ca-bb6c-498c-a6f5-811dcd370140', area: "Windhoek", name: 'Okuryangava' },
    { id: '79c8ff93-e630-411c-9e9b-a0770953e70d', area: "Windhoek", name: 'Lafrenz' },
    { id: 'e229f2bc-7870-4b73-a1ad-964620385e3e', area: "Windhoek", name: 'Farm Brakwater No 48' },
    { id: 'dcd87f40-fbe0-4837-b4b4-91a6ade5613c', area: "Windhoek", name: 'Farm Emmarentia No 380' },
    { id: 'c8fa79d6-f8b2-451b-ae81-1f4901c1cbf3', area: "Windhoek", name: 'Farm Dobra No 49' },
    { id: '0e7c3f3e-c6f1-46f4-9327-b755f5273426', area: "Windhoek", name: 'Farm Nubuamis No 37' },
    { id: 'e94581bf-84a6-4b37-b9ff-2e4eaf552d29', area: "Windhoek", name: 'Thorn Valley' },
    { id: 'c79106f4-8e41-41c7-992a-88184979f846', area: 'outside', name: 'Zambezi Region' },
    { id: '96691002-a068-4ace-8f49-ba19f1513911', area: 'outside', name: 'Kavango East Region' },
    { id: 'b75be13b-981c-4593-b9e7-815ab344a26a', area: 'outside', name: 'Kavango West Region' },
    { id: '8ab38641-97e0-4905-8368-ca99bcd66ce8', area: 'outside', name: 'Ohangwena Region' },
    { id: 'b949705c-2b4c-4e5f-983f-163d27b6e08c', area: 'outside', name: 'Oshikoto Region' },
    { id: '41f50767-ca0c-4c25-9c11-5c6c1ae150bf', area: 'outside', name: 'Oshana Region' },
    { id: 'e0babda7-c576-4f39-aeb5-9e2488b0a90b', area: 'outside', name: 'Omusati Region' },
    { id: '966cfb72-3688-4407-a77f-7d3fa75e6016', area: 'outside', name: 'Kunene Region' },
    { id: '3aeaf8ed-37bd-44b0-b20c-1e8ac6aee1a2', area: 'outside', name: 'Erongo Region' },
    { id: 'ab2c9077-f16f-4ba9-8a4e-4843a9de823a', area: 'outside', name: 'Otjozondjupa Region' },
    { id: '99232129-8915-463a-890e-a0c361daab29', area: 'outside', name: 'Omaheke Region' },
    { id: '66ddea31-e040-4ac1-8322-d18a12528760', area: 'outside', name: 'Hardap Region' },
    { id: '86505e50-81ab-4540-820a-1ca140e88cb2', area: 'outside', name: 'Kharas Region' },
    { id: '2d0b0634-be0e-419b-b8f2-a9ca60d64028', area: 'outside', name: 'Other' },
];

function CustomerDetails({ ticket, customer }) {
    const { priorityCustomers } = useSelector(state => state.services);
    
    if (ticket == null) {
        return (
            <div>
                <div className="informationContainer informationEmpty">
                    <p>No tickets available</p>
                </div>
            </div>
        );
    }

    const priorityCustomer = priorityCustomers.find(a => a.id === ticket.priorityCustomer);

    if (!customer) {
        return (
            <div>
                <div className="informationContainer informationEmpty">
                    <p>No customer details available</p>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className="informationContainer" style={{paddingTop:0}}>
                <div className="informationRow" style={{background: ticket.priority ? "var(--green)" : "var(--gray)", paddingTop:"10px", paddingBottom:"10px"}}>
                    <label style={{color: ticket.priority ? "#fff" : "inherit"}}>Priority Customer</label>
                    {ticket.priority > 0
                        ? <span style={{color: ticket.priority ? "#fff" : "inherit"}}>{priorityCustomer != null ? priorityCustomer.name : ''}</span>
                        : <span style={{color: ticket.priority ? "#fff" : "inherit"}}>No</span>
                    }
                </div>
                <div className="informationRow">
                    <label>Full Name</label>
                    {!customer.fullname.length
                        ? <span>No Customer details</span>
                        : <span>{customer.fullname}</span>
                    }
                </div>
                <div className="informationRow">
                    <label>Mobile Number</label>
                    {!customer.mobileNumber.length
                        ? <span>Unavailable</span>
                        : <span>{customer.mobileNumber}</span>
                    }
                </div>
                {customer.email != null && customer.email.toString().length > 0 && (
                    <div className="informationRow">
                        <label>Email</label>
                        <span>{customer.email}</span>
                    </div>
                )}
                {customer.erfNumber != null && customer.erfNumber.toString().length > 0 && (
                    <div className="informationRow">
                        <label>ERF Number</label>
                        <span>{customer.erfNumber}</span>
                    </div>
                )}
                {customer.township != null && customer.township.toString().length > 0 && (
                    <div className="informationRow">
                        <label>Township</label>
                        <span>{townships.find(a => a.id === customer.township)?.name || 'Unavailable'}</span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default CustomerDetails;
